import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import JournalEntryCard from "./Card"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import { getTransactionItem } from "../../../redux/sagas/items/accounting"

class JournalEntryDetails extends React.Component {

  state = {
    journalEntries: [],
    running: false,
    error: null,
  }

  componentDidMount() {
    this.props.loadGLAccounts()
    this.loadJournalEntries()
  }

  loadJournalEntries = () => {

    this.setState({
      running: true,
      error: null,
    })

    const { params: { id: transactionId }} = this.props

    blockingFetchService(
      accessToken => apiServerApi.loadJournalEntryByTransactionId(accessToken, transactionId),
      resp => {
        const jsonData = JSON.parse(resp),
        journalEntries = jsonData.pageItems.map(getTransactionItem)
        this.setState({ journalEntries })
      },
      error => {
        console.error(error)
        this.setState({ error: error.text })
      },
      _ => this.setState({ running: false })
    )
  }

  render() {

    const { glAccounts } = this.props,
    { journalEntries } = this.state
  
    return journalEntries.length
      ? <JournalEntryCard 
          journalEntries={ journalEntries } 
          glAccounts={ glAccounts }
          loadData={ this.loadJournalEntries }
        /> 
      : <p>Loading ..</p>
  }
}

JournalEntryDetails.propTypes = {
  glAccounts: PropTypes.array,
}

const mapStateToProps = state => {

  const glAccounts = DckSelectors.selectAllItems(state, ItemTypes.GLAccount)
  return { glAccounts }
},

mapDispatchToProps = dispatch => ({
  loadGLAccounts: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.GLAccount)),
})

export default connect(mapStateToProps, mapDispatchToProps)(JournalEntryDetails)



// WEBPACK FOOTER //
// ./src/components/Accounting/JournalEntries/Details.js